import { Rect } from '../pages/mindmap/use-mindmap-viewport';

/**
 * Calculates which rectangle from an array of rectangles is the furthest away from the viewport.
 * @param boundingClientRects Rectangles that should be analyzed.
 * @returns The x and y amount the node needs to be moved to be completely visible in the viewport.
 */
export const determineFurthestFromViewportRectangle = (
  boundingClientRects: Rect[],
): { moveXAmount: number; moveYAmount: number } => {
  let moveXAmount = 0;
  let moveYAmount = 0;
  // find the rect which is furthest away from the viewport
  boundingClientRects.forEach((boundingClientRect) => {
    let nodeMoveXAmount = 0;
    let nodeMoveYAmount = 0;

    // determine x movement
    const isOnLeftSide = boundingClientRect.right < 0 || boundingClientRect.left < 0;
    if (isOnLeftSide) {
      nodeMoveXAmount = -boundingClientRect.left;
    }
    const isOnRightSide = boundingClientRect.left > window.innerWidth || boundingClientRect.right > window.innerWidth;
    if (isOnRightSide) {
      nodeMoveXAmount = -(boundingClientRect.right - window.innerWidth);
    }

    // determine y movement
    const isOnTopSide = boundingClientRect.bottom < 0 || boundingClientRect.top < 0;
    if (isOnTopSide) {
      nodeMoveYAmount = -boundingClientRect.top;
    }
    const isOnBottomSide =
      boundingClientRect.top > window.innerHeight || boundingClientRect.bottom > window.innerHeight;
    if (isOnBottomSide) {
      nodeMoveYAmount = -(boundingClientRect.bottom - window.innerHeight);
    }

    if (Math.abs(nodeMoveXAmount) > Math.abs(moveXAmount) || Math.abs(nodeMoveYAmount) > Math.abs(moveYAmount)) {
      moveXAmount = nodeMoveXAmount;
      moveYAmount = nodeMoveYAmount;
    }
  });

  return { moveXAmount, moveYAmount };
};
